.e{justify-content:center;}